import React from 'react'

const withLocalization = (Component) => (props) => {
  const localization = localStorage.getItem('localization') || 'en'
  return <Component localization={localization} {...props} />
}

export default withLocalization
